<template>
  <el-dialog id="cc" :center="true" :close-on-click-modal="false" title="学生基本信息" :visible.sync="showEdit"
    @close="closeEditDialog">
    <el-form :rules="rules" ref="order" :model="order">
      <el-form-item label="学生姓名:" style="width: 80%;">
        <span>{{ order.studentName }}</span>
      </el-form-item>
      <el-form-item label="学生年级:" style="width: 80%;">
        <span>{{ order.gradeIdArrToStr }}</span>
        <!--        <el-cascader v-model="order.grade" :options="order.gradeList" :props="props"></el-cascader>-->
      </el-form-item>
      <el-form-item label="学生性别:" style="width: 80%;">
        <span v-if="order.sex == 1">男</span>
        <span v-if="order.sex == 2">女</span>
      </el-form-item>
      <el-form-item label="家庭住址:" style="width: 80%;">
        <span>{{ order.address }}</span>
      </el-form-item>
      <el-form-item label="家长电话:" style="width: 80%;">
        <span>{{ order.parentPhoneNumber }}</span>
      </el-form-item>
      <el-form-item label="课程类别:">
        <span>{{ order.categoryIdArrToStr }}</span>
      </el-form-item>
      <el-form-item label="学生类型:">
        <span v-if="order.classType == 1">规划</span>
        <span v-if="order.classType == 2">线下</span>
        <span v-if="order.classType == 3">纯补课</span>
      </el-form-item>
      <!-- <el-form-item label="诊断教师:">
        {{ order.teacherName }}
      </el-form-item>
      <el-form-item label="诊断时间:">
        <span
          >{{ order.startTimeDay }}&nbsp;&nbsp;&nbsp;&nbsp;{{
            order.startTimeHour[0]
          }}&nbsp;至&nbsp; {{ order.startTimeHour[1] }}</span
        >
      </el-form-item> -->

      <el-form-item label="线上诊断教师:">
        {{ order.teacherIdOnline }}
      </el-form-item>
      <el-form-item label="线上诊断时间:">
        <span>{{ order.onlineTime[0] }}&nbsp;&nbsp;&nbsp;&nbsp;{{
          order.onlineTime[1]
        }}&nbsp;至&nbsp; {{ order.onlineTime[2] }}</span>
      </el-form-item>
      <el-form-item>是否线上预约:&nbsp;&nbsp;<span v-if="order.onlineStatus == '1'">是</span> <span
          v-else>否</span></el-form-item>
      <el-form-item label="线下诊断教师:">
        {{ order.teacherIdOffline }}
      </el-form-item>
      <el-form-item label="线下诊断时间:">
        <span>{{ order.offlineTime[0] }}&nbsp;&nbsp;&nbsp;&nbsp;{{
          order.offlineTime[1]
        }}&nbsp;至&nbsp; {{ order.offlineTime[2] }}</span>
      </el-form-item>
      <el-form-item style="margin-top: 22px">是否线下预约:&nbsp;&nbsp;<span v-if="order.offlineStatus == '1'">是</span> <span
          v-else>否</span></el-form-item>
      <el-form-item>备注:&nbsp;&nbsp;{{ order.remarks }}</el-form-item>
      <el-divider content-position="center">付款信息</el-divider>


      <el-form-item>订单状态:&nbsp;&nbsp;<span v-if="order.orderStatus == '1'">已成单</span> <span
          v-else>已关单</span></el-form-item>

      <el-form-item style="margin-top: 22px" label="是否交定金：">
        <span v-if="order.customerIspay === '1'">是</span>
        <el-form-item style="margin-left: 32px;" v-if="order.customerIspay === '1'" label="付款金额：">{{
          order.customerPaymoney }}
        </el-form-item>
        <el-form-item style="margin-left: 32px;" v-if="order.customerIspay === '1'" label="付款时间：">{{ order.customerPaytime
        }}
        </el-form-item>
        <el-form-item style="margin-left: 32px;" v-if="order.customerIspay === '1'" label="付款渠道：">{{ order.payType2 }}
        </el-form-item>
        <span v-if="order.customerIspay === '2'">否</span>
      </el-form-item>
      <el-form-item style="margin-top: -22px;" label="尾款付款情况：">
        <span v-if="order.customerIsallpay === '1'">全额尾款</span>
        <span v-if="order.customerIsallpay === '2'">分期尾款</span>
        <span v-if="order.customerIsallpay === '3'">取消尾款</span>

        <el-form-item v-if="order.customerIsallpay === '1'">
          <div v-if="order.customerIsallpay === '1'">全额尾款学业课时数：{{ order.classHour }}</div>
          <div v-if="order.customerIsallpay === '1'">全额尾款家庭教育课时数：{{ order.familyHour }}</div>
        </el-form-item>

        <el-form-item v-if="order.customerIsallpay === '2'" v-for="(item, index) in order.stages" :key="index">
          <span>第{{ index + 1 }}期：{{ item.stagesMoney }} &nbsp; &nbsp;
            付款日期： {{ item.stagesDate }}&nbsp; &nbsp; &nbsp; &nbsp;
            付款渠道：
            <span v-if="item.payType === 1 || item.payType === '1' ">现金</span>
            <span v-if="item.payType === 2 || item.payType === '2' ">微信</span>
            <span v-if="item.payType === 3 || item.payType === '3' ">支付宝</span>
            <span v-if="item.payType === 4 || item.payType === '4' ">银行卡</span>
            <span v-if="item.payType === 5 || item.payType === '5' ">公户</span>
            <span v-if="item.payType === 6 || item.payType === '6' ">小鹅通</span>
            <span v-if="item.payType === 7 || item.payType === '7' ">美团</span>
            <span v-if="item.payType === 8 || item.payType === '8' ">公户（桑穆）</span>
            <span v-if="item.payType === 9 || item.payType === '9' ">公户（博川）</span>
            <span v-if="item.payType === 10 || item.payType === '10' ">公户（蒙正心理）</span>

            &nbsp; &nbsp; &nbsp; &nbsp;
            分期尾款学业课时数： <span>{{ item.agingFamilyHour}}</span>
            &nbsp; &nbsp; &nbsp; &nbsp;
            分期尾款家庭教育课时数： <span>{{ item.agingClassHour}}</span>

          </span>
        </el-form-item>
        <el-form-item style="margin-left: 32px;">
          <span v-if="order.customerIsallpay === '1'">付款金额：{{ order.customerAllpaymoney }}</span>
        </el-form-item>
        <el-form-item style="margin-left: 32px;">
          <span v-if="order.customerIsallpay === '1'">付款时间：{{ order.customerAllpaytime }}</span>
        </el-form-item>
        <el-form-item style="margin-left: 32px;">
          <span v-if="order.customerIsallpay === '1'">付款渠道：{{ order.payAllType2 }}</span>
        </el-form-item>
      </el-form-item>
      <el-form-item>是否续费:&nbsp;&nbsp;<span v-if="order.isRenew == '1'">是</span> <span v-else>否</span></el-form-item>
      <el-form-item v-if="order.isRenew == '1'" v-for="(item, index) in order.renew" :key="index">
        <span>第{{ index + 1 }}期：{{ item.renewMoney }} &nbsp; &nbsp;
          付款日期： {{ item.renewTime }}&nbsp; &nbsp; &nbsp; &nbsp;
          付款渠道：
          <span v-if="item.renewType === 1">现金</span>
          <span v-if="item.renewType === 2">微信</span>
          <span v-if="item.renewType === 3">支付宝</span>
          <span v-if="item.renewType === 4">银行卡</span>
          <span v-if="item.renewType === 5">公户</span>

          <!-- &nbsp; &nbsp; &nbsp; &nbsp;
          续费学业课时数： <span>{{ item.classHourRenew}}</span>
          &nbsp; &nbsp; &nbsp; &nbsp;
          续费家庭教育课时数： <span>{{ item.familyHourRenew}}</span> -->

        </span>
        <div>续费学业课时数： <span>{{ item.classHourRenew}}</span></div>
        <div>续费家庭教育课时数： <span>{{ item.familyHourRenew}}</span></div>
      </el-form-item>
      <el-form-item label="查看诊断报告">
        <el-button type="primary" size="small" @click="toDiagnosis">点击查看</el-button>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeEditDialog">关闭</el-button>
      <!--            <el-button type="primary" @click="saveEditForm">保存</el-button>-->
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";

export default {
  components: {},
  data () {
    return {
      expireTimeOption: {
        disabledDate (date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      teachers: [], //老师集合
      categoryList: [], //课程集合
      props: {
        label: "gradeName",
        children: "children",
        value: "id"
      },
      payTypes: [
        {
          value: 1,
          label: "现金"
        },
        {
          value: 2,
          label: "微信"
        },
        {
          value: 3,
          label: "支付宝"
        },
        {
          value: 4,
          label: "银行卡"
        },
        {
          value: 5,
          label: "公户"
        },
        {
          value: 6,
          label: "小鹅通"
        },
        {
          value: 7,
          label: "美团"
        },
        {
          value: 8,
          label: "公户（桑穆）"
        },
        {
          value: 9,
          label: "公户（博川）"
        },
        {
          value: 10,
          label: "公户（蒙正心理）"
        },
      ], // 付款渠道选项
      customer: {},
      order: {
        renew: [
          {
            renewType: "",//续费方式
            renewTime: "",//续费时间
            renewMoney: ""//续费金额
          }
        ],
        isRenew: "",//是否续费
        orderStatus: "",
        remarks: "",//备注
        customerIsallpay: "",
        onlineStatus: "1",//线上诊断标识x
        offlineStatus: "1",//线下诊断标识
        teacherIdOnline: "",//线上诊断老师
        teacherIdOffline: "",//线下诊断老师
        onlineTime: [],// 线上诊断时间
        offlineTime: [],// 线下诊断时间
        startTimeDay: "", //诊断时间天数
        startTimeHour: "", //诊断时间小时段
        gradeIdArrToStr: "", //年级字符串
        categoryIdArrToStr: "", //年级字符串
        orderIspay: "",
        isDiagnosisAllPay: "", //是否交诊断费
        customerPaymoney: "", //诊断费用
        customerPaytime: "", //诊断费用付款时间
        payType: "", //诊断费用付款方式
        payAllType2: "", //诊断费用付款方式
        customerAllpaymoney: "", //全款费用
        customerAllpaytime: "", //交全款时间
        isAllPay: "",
        payType2: "", //诊断费用
        orderIsallpay: "", //付款方式
        studentName: "", //学生姓名
        gradeList: [], //年级
        grade: [], //年级id
        classType: '',
        sex: "", // 性别
        address: "", //家庭地址
        parentPhoneNumber: "", //家长电话
        teacherId: "", //老师id
        teacherName: "", //老师id
        startTime: "", //授课时间
        payAlltype: "", //全款付款方式
        categoryId: "", //课程id
        type: "", //成交状态
        customerInformationId: "", //客资id
        classHour: "",
        familyHour: "",
        stages: [
          {
            stagesMoney: "", // 分期金额
            stagesDate: "", // 分期时间
            payType: "" // 付款渠道
          }
        ]
      },
      showEdit: false,
      rules: {
        studentName: [
          {
            required: true,
            message: "请输入学生名称",
            trigger: "blur"
          }
        ],
        grade: [
          {
            required: true,
            message: "请选择年级",
            trigger: "change"
          }
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        address: [
          {
            required: true,
            message: "请输入家庭住址",
            trigger: "blur"
          }
        ],
        categoryId: [
          { required: true, message: "请选择课程类别", trigger: "change" }
        ],
        teacherId: [
          { required: true, message: "请选择授课教师", trigger: "change" }
        ],
        startTime: [
          { required: true, message: "请选择授课时间", trigger: "change" }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    init (customerId) {
      this.customerId = customerId;
      this.showEdit = true;
      axios
        .get(`${apiBaseUrl}/customerinformation/getOne/${customerId}`,{  headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }})
        .then(res => {
          console.log(res.data.data.list);
          if (res.data.code === 200) {
            this.order.classHour = res.data.data.list.classHour
            this.order.familyHour = res.data.data.list.familyHour

            this.order.orderStatus = res.data.data.list.orderStatus
            this.order.teacherIdOnline = res.data.data.list.onlineTeacherName
            this.order.teacherIdOffline = res.data.data.list.offlineTeacherName
            if (res.data.data.list.onlineTime !== null) {
              this.order.onlineTime = JSON.parse(res.data.data.list.onlineTime)
            }
            if (res.data.data.list.offlineTime !== null) {
              this.order.offlineTime = JSON.parse(res.data.data.list.offlineTime)
            }
            this.order.customerIspay = res.data.data.list.customerIspay + "";
            this.order.isRenew = res.data.data.list.isRenew
            this.order.customerIsallpay =
              res.data.data.list.customerIsallpay + "";
            this.order.customerAllpaymoney =
              res.data.data.list.customerAllpaymoney;
            this.order.customerAllpaytime =
              res.data.data.list.customerAllpaytime;
            this.order.onlineStatus = res.data.data.list.onlineStatus
            this.order.offlineStatus = res.data.data.list.offlineStatus
            this.order.remarks = res.data.data.list.remarks
            this.order.parentPhoneNumber = res.data.data.list.parentPhoneNumber;
            this.order.gradeIdArrToStr = res.data.data.list.gradeIdArrToStr;
            this.order.teacherName = res.data.data.list.userName;
            this.order.classType = res.data.data.list.classType;
            this.order.categoryIdArrToStr =
              res.data.data.list.categoryIdArrToStr;
            this.order.studentName = res.data.data.list.customerStudent;
            this.order.sex = res.data.data.list.sex;
            this.order.grade = res.data.data.list.gradeIdArr2;
            this.order.courseCategoryId = res.data.data.list.categoryIdArr2;
            this.order.address = res.data.data.list.address;
            this.order.customerPaytime = res.data.data.list.customerPaytime;
            this.order.teacherId = res.data.data.list.customerTeacherid;
            // this.order.startTime = JSON.parse(res.data.data.list.startTime);
            // this.order.startTimeDay = this.order.startTime[0];
            // this.order.startTimeHour = this.order.startTime[1];

            this.order.customerPaymoney = res.data.data.list.customerPaymoney;

            this.order.payType = res.data.data.list.payType;
            this.order.payType2 = res.data.data.list.payType2;
            this.order.payAllType2 = res.data.data.list.payAllType2;

            this.order.payAlltype = res.data.data.list.payAlltype;
            this.order.stages = JSON.parse(res.data.data.list.stages)
            this.order.renew = JSON.parse(res.data.data.list.renew)
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        });
    },
    isFull () {
      this.order.stages = [
        {
          stagesMoney: "", // 分期金额
          stagesDate: "", // 分期时间
          payType: "" // 付款渠道
        }
      ];
    },
    isNo () {
      this.order.customerAllpaymoney = "";
      this.order.customerAllpaytime = "";
      this.order.payAlltype = "";
    },
    //添加输入框
    addInput () {
      this.order.stages.push({
        stagesMoney: "",
        stagesDate: "",
        payType: "" // 付款渠道
      });
    },
    //减少输入框
    removeItem () {
      if (this.order.stages.length > 1) {
        this.order.stages.pop();
      } else {
        this.order.stages.splice(0, this.order.stages.length);
      }
    },
    orderShow (customer) {
      this.showEdit = true;
      this.customer = customer;
      this.order.type = customer.type;
      this.order.customerInformationId = customer.customerId;
    },
    closeEditDialog () {
      // this.$emit("resetSuccesType", this.customer);
      this.showEdit = false;
      this.order.onlineTime = []
      this.order.offlineTime = []
    },
    //
    toDiagnosis () {
      this.$router.push({
        path: "/diagnosisdetail",
        query: {
          customerId: this.customerId
        }
      });
    },
    getGrade () {
      axios
        .get(`${apiBaseUrl}/grade/getGrade`,{  headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }})
        .then(res => {
          this.order.gradeList = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取年级列表失败",
            type: "error"
          });
        });
    },
    getTeachers () {
      axios
        .get(`${apiBaseUrl}/schedule/teacherlist`,{ headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }})
        .then(res => {
          this.teachers = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取老师列表失败",
            type: "error"
          });
        });
    },
    //获取课程类别
    getCategoryList () {
      axios
        .get(`${apiBaseUrl}/schedule/categorylist`,{  headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }})
        .then(res => {
          this.categoryList = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取课程列表失败",
            type: "error"
          });
        });
    },
    saveEditForm () {
      this.$refs["order"].validate(valid => {
        if (valid) {
          axios
            .post(`${apiBaseUrl}/teachStuInfo/save`, this.order)
            .then(res => {
              if (res.data.code === 200) {
                this.showEdit = false;
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error"
                });
              }
            });
        }
      });
    }
  },
  beforeCreate () { },

  created () {
    this.getGrade();
    this.getTeachers();
    this.getCategoryList();
  },

  beforeMount () { },

  mounted () { },

  beforeUpdate () { },

  updated () { },

  beforeDestroy () { },
  destroyed () { },

  activated () { }
};
</script>

<style scoped>
/* 兼容移动端 */
@media screen and (max-width: 750px) {

  /* 兼容移动端 */
  #cc>>>.el-dialog {
    width: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// src/manager/components/OrderDetail.vue